/**
 * Accessibility Utilities to provide accessible experience for the design system.

 * @see https://developer.mozilla.org/en-US/docs/Learn/Accessibility/CSS_and_JavaScript
 */

/**
 * Indicates that user has notified the system that they prefer an interface
 * that removes or replaces the types of motion-based animation that trigger
 * discomfortfor those with vestibular motion disorders.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-reduced-motion
 */
export function osHasReducedMotion() {
  if(!window.matchMedia) return false;
  var matchMediaObj = window.matchMedia('(prefers-reduced-motion: reduce)');
  if(matchMediaObj) return matchMediaObj.matches;
  return false;
}
